import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./LoginPage";
import Dashboard from "./Dashboard";
import { supabase } from "./supabaseClient";
import { useEffect, useState } from "react";
import RegisterPage from "./RegisterPage";
import Subscription from "./Subscription";
import Download from "./Download";
import Settings from "./Settings";
import Tutorial from "./Tutorial";
import InstallPC from "./InstallPC";
import InstallAndroid from "./InstallAndroid";

function App() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    // Récupère la session active à l'ouverture
    const currentSession = supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
    });

    // Ecoute les changements de session (login/logout)
    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    // Nettoyage du listener à la destruction
    return () => {
      listener?.subscription.unsubscribe();
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={!session ? <LoginPage /> : <Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={session ? <Dashboard /> : <Navigate to="/" />} />
        <Route path="/register" element={!session ? <RegisterPage /> : <Navigate to="/dashboard" />} />
        <Route path="/subscription" element={session ? <Subscription /> : <Navigate to="/" />} />
        <Route path="/download" element={session ? <Download /> : <Navigate to="/" />} />
        <Route path="/settings" element={session ? <Settings /> : <Navigate to="/" />} />
        <Route path="/tutorial" element={session ? <Tutorial /> : <Navigate to="/" />} />
        <Route path="/install-pc" element={<InstallPC />} />
        <Route path="/install-android" element={<InstallAndroid />} />
        <Route path="*" element={<Navigate to={session ? "/dashboard" : "/"} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
